<template>
  <header class="page-header">
    <div class="page-header__text">
      <h1 class="page-header__title">{{ title }}</h1>
      <p v-if="subtitle" class="page-header__subtitle">{{ subtitle }}</p>
    </div>
    <div v-if="$slots.actions" class="page-header__actions">
      <slot name="actions" />
    </div>
  </header>
</template>

<script>
export default {
  name: "PageHeader",
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: "" },
  },
};
</script>

<style scoped lang="scss">
.page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 28px;

  &__text {
    flex: 1;
    min-width: 0;
  }

  &__title {
    font-size: 28px;
    font-weight: 700;
    color: #0f172a;
    line-height: 1.2;
    letter-spacing: -0.01em;
    margin: 0 0 4px;
  }

  &__subtitle {
    font-size: 14px;
    line-height: 1.5;
    color: rgba(15, 23, 42, 0.62);
    margin: 0;
    max-width: 720px;
  }

  &__actions {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
  }
}

@media (max-width: 600px) {
  .page-header {
    flex-direction: column;
    gap: 16px;
    margin-bottom: 20px;

    &__title {
      font-size: 22px;
    }

    &__actions {
      width: 100%;
    }
  }
}
</style>
